import { FC, useEffect, useState } from 'react'
import GlobalSpinner from '../globalsSpinner/GlobalSpinner';
import { FormInputNumber, FormRowHorizontal } from '../formRow/FormRow';
import { Button } from '../Button';
import { AdvertisingInfo, getAdvertisingInfo, patchAdvertisingInfo } from '../../../api/playersApi';
import { useParams } from 'react-router-dom';

const Advertising:FC = () => {
    let [isLoading, setIsLoading] = useState(false)
    let [adSlotDuration, setAdSlotDuaration] = useState<number | ''>('')
    let [isAdSlotDuartionError, setIsAdSlotDurationError] = useState(false)
    let [maxDuration, setMaxDuration] = useState<number | ''>('')
    let [isMaxDurationError, setIsMaxDurationError] = useState(false)
    let [minDuration, setMinDuration] = useState<number | ''>('')
    let [isMinDurationError, setIsMinDurationError] = useState(false)

    let {id : playerId} = useParams<{id:string}>();

    useEffect(() => {
        async function fetchData(){
            setIsLoading(true);
            await updateAdvertisingInfo()
            setIsLoading(false);
        }

        fetchData()
    }, [])

    const isDurationValid = (value: number | '') => {
        if (value === '') return false;
        
        return value >= 0;
    };

    const updateAdvertisingInfo = async () => {
        let result = await getAdvertisingInfo(playerId)
        if (result.type == "succes") {
            setAdSlotDuaration(result.data.data.slotDuration);
            setMaxDuration(result.data.data.maxDuration);
            setMinDuration(result.data.data.minDuration);
        }
    }

    const saveAdvertisingInfo = async () => {
        let isValid = true;
        if(!isDurationValid(adSlotDuration)){
            setIsAdSlotDurationError(true);
            isValid = false;
        }
        if(!isDurationValid(maxDuration)){
            setIsMaxDurationError(true);
            isValid = false;
        }
        if(!isDurationValid(minDuration)){
            setIsMinDurationError(true);
            isValid = false;
        }

        if(!isValid) return;

        let request: AdvertisingInfo = {
            slotDuration: +adSlotDuration,
            maxDuration: +maxDuration,
            minDuration: +minDuration
        }


        setIsLoading(true)
        await patchAdvertisingInfo(playerId, request);
        await updateAdvertisingInfo()
        setIsLoading(false)
    }

    return <>
        <div className="advertising-block" style={{width:500}}>
            <FormRowHorizontal>
                <FormInputNumber
                    id="ad-slot-duration"
                    title="Ad Slot Duration (sec)"
                    isError={isAdSlotDuartionError}
                    errorMessage="Please enter correct Ad Slot Duartion"
                    value={adSlotDuration}
                    onChange={e => {
                        setIsAdSlotDurationError(false)
                        e.target.value === '' ? setAdSlotDuaration('') : setAdSlotDuaration(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="max-duaration"
                    title="Max Duration (sec)"
                    isError={isMaxDurationError}
                    errorMessage="Please enter correct max duaration"
                    value={maxDuration}
                    onChange={e => {
                        setIsMaxDurationError(false)
                        e.target.value === '' ? setMaxDuration('') : setMaxDuration(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <FormRowHorizontal>
                <FormInputNumber
                    id="min-duaration"
                    title="Min Duration (sec)"
                    isError={isMinDurationError}
                    errorMessage="Please enter correct min duaration"
                    value={minDuration}
                    onChange={e => {
                        setIsMinDurationError(false)
                        e.target.value === '' ? setMinDuration('') : setMinDuration(+e.target.value)
                    }}
                />
            </FormRowHorizontal>
            <div className="form-btn">
                <Button color="green" label="Save" onClick={saveAdvertisingInfo} />
            </div>
        </div>
        <GlobalSpinner isShow={isLoading} />
    </>
}

export default Advertising